define('rebrush/system/validation',[],function() {
    window.Validation.addAllThese([
        // ['validate-select', 'Please select an option.', function(v) {
        //     return ((v != "none") && (v != null) && (v.length != 0));
        // }],
            ['required-entry', 'This is a required field.', function(v, element) {
            if ('SELECT' === element.nodeName.toUpperCase()) {
                this.error = Translator.translate('Please select an option.');
                return window.Validation.get('validate-select').test(v, element);
            }

            this.error = Translator.translate('This is a required field.');
            return !window.Validation.get('IsEmpty').test(v);
        }]
    ]);

    // fixes silent validation exception for addToCartForm when in engraving legal popup
    const originalValidationIsVisible = window.Validation.isVisible;

    window.Validation.isVisible = function(elm) {
        if (document.querySelector('.print-legal-popup-open')) {
            return false;
        }
        return originalValidationIsVisible(elm);
    };
});

